import momemt from 'moment';

export default function Events() {
	$.ajax( {
		url: 'https://rest.bandsintown.com/artists/id_15500411/events?app_id=45PRESS_marzzmusic',
		method: 'GET',
		dataType: 'json',
		error: () => {
		},
		success: data => {
			const events = $( '#events' );
			let html = '';
			console.log( data );
			if ( data.length ) {
				for ( let event of data ) {
					const location = event.venue.city + ', ' + event.venue.region;
					html += '<div class="event">';
					html += '<div class="event-date">' + momemt( event.datetime ).format( 'MMM DD' ) + '</div>';
					html += '<div class="event-location">' + location + '<br>' + event.venue.name + '</div>';
					html += '<div class="event-links">';
					for ( let offer of event.offers ) {
						html += '<a href="' + offer.url + '" target="_blank" class="btn"><span>' + offer.type + '</span><span class="marquee-text" aria-hidden="true">'+ offer.type + ' ' + offer.type + ' ' + offer.type + ' ' + offer.type + '</span></a>';
					}
					html += '</div>';
					html += '</div>';
				}
				html+='<div class="more"><a href="#" class="btn"><span>More Dates</span><span class="marquee-text" aria-hidden="true">More Dates More Dates More Dates</span></a></div>';
				events.html( html );

				$( '#events .more' ).hide();
				if ( $( '#events>div' ).length > 6 ) {
					$( '#events .more' ).show();
				}
			} else {
				events.html( '<div class="event no-event">No upcoming events.</div>' );
			}
			$( '#events .more a' ).on( 'click', function ( e ) {
				e.preventDefault();
				$( '#events' ).addClass('seeall');
				$( this ).hide();
			} );
		},
		error: console.log('Error fetching')
	} );

	

}